import store from "@/store";
//  按钮权限自定义指令
const btnhasPermission = {
  mounted(el, binding, vnode) {
    const { value } = binding;
    let f = store.getters.btnLimit.some(p => {
      return value.indexOf(p) !== -1;
    });
    if (!f) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
}
export const hasPermission = (key) => {
  return store.getters.btnLimit.some(p => {
    return key === p
  })
}

export default btnhasPermission
